module.exports = __webpack_public_path__ + "static/media/TinyCelebrate2_72dpi.6c34e187.png";